<template>
  <div class="input-checkbox">
    <!-- 'input-checkbox__input--has-error': hasOnLoadError || hasStoredError, -->
    <input
      :id="id"
      type="checkbox"
      class="input-checkbox__input"
      :class="{
        'input-checkbox__input--is-disabled': disabled,
      }"
      :required="required"
      :aria-required="required"
      :name="context.name"
      :checked="checked"
      :disabled="disabled"
      :aria-disabled="disabled"
      @change="onChange"
    />
    <label :for="id" class="input-checkbox__label">
      <!-- because checkbox itself is rendered as pseudo element
         in a flex context -->
      <span>
        <slot />
      </span>
    </label>
  </div>
</template>

<script>
export default {
  inject: ['context', 'onOptionChange'],
  props: {
    value: {
      type: String,
    },

    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uuid: this.$uuid.v1(),
    };
  },
  computed: {
    checked() {
      return this.context.internalValue.includes(this.value);
    },
    id() {
      return `${this.context.id}-${this.value}`;
    },
  },
  mounted() {},
  methods: {
    onChange(event) {
      console.log('CHECK', event);
      const checked = event.target.checked;
      if (!checked) {
        // by default prevent removing
        // because it shall be handled via internalValue
        event.target.checked = true;
      }
      this.onOptionChange(this.value, checked);
    },
  },
};
</script>
